import {Link, useParams, useLocation} from 'react-router-dom';
import React, {useEffect, useState} from "react";
import DOMPurify from 'dompurify';
import {Formik, Form, Field, ErrorMessage, FormikValues, FormikHelpers, useFormik} from 'formik';
import * as Yup from 'yup'

const Header = () => {
    const [data, setData] = useState([]);
    const [stiky, setStiky] = useState(true);
    const [menu, setMenu] = useState('');
    const {slug} = useParams();
    const location = useLocation();

    useEffect(() => {
        toggleDarkTheme();

        let root = document.getElementById('root');
        fetch( global.config.api + `/?method=header_menu`)
            .then(response => response.json())
            .then(json => {
                if (json) {
                    setMenu(json);
                    root.classList.remove('loading_data');
                    // console.log('header_menu', )
                } else {
                    console.error('Invalid data structure', json);
                }
            })
            .catch(error => console.error('Error fetching data:', error));

        // Stiky navigation functionality
        window.onscroll = function(e) {
            setStiky(this.oldScroll > this.scrollY)
            ///console.log(stiky);
            this.oldScroll = this.scrollY;
        }
        // let wpadminbar = document.getElementById('wpadminbar');
        // document.getElementById('wp--skip-link--target').style = wpadminbar ? `top:32px` : `top:0px`
        document.getElementById('header').style = stiky ? `top:0` : `top:-91px`;
        let sidebar = document.getElementById('side_bar');
        if(sidebar){
            sidebar.style = stiky ? `top:112px` : `top:20px`;
        }
    }, [location])

    const toggleDarkTheme = () => {
        let root = document.getElementById('root');
        if(location.pathname == '/'){
            if (!root.classList.contains("dark_theme")){
                root.classList.add('dark_theme');
                // console.log('dark_theme');
            }
        } else {
            if (root.classList.contains("dark_theme")){
                root.classList.remove('dark_theme');
                // console.log('LIGHT_theme');
            }
        }
    }


    const handleBurgerButton = () => {
        var node = document.getElementById('header');
        node.classList.toggle('header_mobile_menu_open');
    }

    // const searchField = (e) => {
    //     <Formik
    //         initialValues={{
    //             search_field: '',
    //         }}
    //         onSubmit={(values, actions) => {
    //             console.log(values);
    //         }}
    //     >
    //         { props => (
    //             <form className="search-form" onSubmit={props.handleSubmit}>
    //                 <div className="input-wrapper">
    //                     <input
    //                         name="search_field"
    //                         placeholder="Поиск по сайту"
    //                         onBlur={props.handleBlur}
    //                         value={props.values.search_field}
    //                         onChange={props.handleChange}
    //                         className="search-input"
    //                         autoComplete="off"
    //                         minLength="3"
    //                         required=""
    //                     />
    //                     <button type="submit" className='search_icon'></button>
    //                 </div>
    //             </form>
    //         )}
    //     )
    //     </Formik>
    //     console.log('search ' + e);
    // }

    const getPostThumbnail = (avatar) => {
        return avatar == '' ? '/wp-content/plugins/blog_tools/images/no_avatar.png' : avatar;
    }

    const buildSearchFeed = (searchResults) => {
        if(Array.isArray(searchResults)) {
            return (
                <div className="search_feed_popup">
                    <div className="search_feed_popup_inner">
                        <ul>
                            {searchResults.map( item => (
                                <li>
                                    <Link to={ item.href } onClick={closeSearchBox}>
                                        <div className="search_feed_icon">
                                            <img src={getPostThumbnail(item.icon)} alt={item.title}/>
                                        </div>
                                        <div className="search_feed_title" dangerouslySetInnerHTML={{__html: checkHTML(item.title)}}></div>
                                    </Link>
                                </li>
                                )
                            )}
                        </ul>
                    </div>
                </div>
            )
        }
    }

    const handleChange = (search_field) => {
        let node = document.querySelector("#search_form");
        //console.log(node.dataset.search + ' - ' + search_field);
        if ( search_field.length > 2 && node.dataset.search != search_field ) {
            fetch( global.config.api + `/?method=search_feed&slug=${slug}&search=` + search_field)
                .then(response => response.json())
                .then(json => {
                    if (json && json.success) {
                        //console.log(json.feed);
                        setData(json.feed);
                        openSearchBox();
                        node.dataset.search = search_field;
                    } else {
                        console.error('Invalid data structure', json);
                    }
                })
                .catch(error => console.error('Error fetching data:', error));

            //console.log(search_field);
        }
    }

    const closeSearchBox = () =>{
        let search_field = document.getElementById('search_field');
        search_field.value = "";
        let node = document.getElementById('search_form');
        if (node.classList.contains("search_results")){
            node.classList.remove('search_results');
        }
        //console.log('closeSearchBox ')
    }
    const openSearchBox = () =>{
        let node = document.getElementById('search_form');
        if (!node.classList.contains("search_results")){
            node.classList.add('search_results');
        }
        //console.log('openSearchBox ')
    }

    const FormikSearchBox = () => {
        const formik = useFormik({
            // Initial values
            initialValues: {
                search_field: '',
            },
            validate: (values) => {
                //console.log('validate ')
                handleChange(values.search_field);
            },

            // On Submit
            onSubmit: (data) => {
                //handleChange(formik.values.search_field);
                //console.log('onSubmit ' + formik.values.search_field)
            }

        });
        //handleChange(formik.values.search_field);
        return (
            <div id="search_form" data-search="">
                <form className="search-form" onSubmit={formik.handleSubmit}>
                    {buildSearchFeed(data)}
                    {formik.errors.search_field && <div className="error">{formik.errors.search_field}</div>}
                    <input className="search-input"
                           id="search_field"
                           name="search_field"
                           type="text"
                           placeholder="Поиск по сайту"
                           onBlur={formik.handleBlur}
                           value={formik.values.search_field}
                           onChange={formik.handleChange}
                           autoComplete="off"
                           minLength="3"
                           required=""
                    />
                    <button type="submit" className='search_icon'></button>
                </form>
            </div>
        )
    }

    const checkHTML = (string) => {
        return DOMPurify.sanitize(string, { USE_PROFILES: { html: true } });
    }

    // const SearchFieldBlock = () => (
    //     <Formik
    //         initialValues={{
    //             search_field: '',
    //         }}
    //         // onSubmit={(data) =>{console.log(data)}}
    //         onSubmit={(values, actions) => {
    //             console.log(values);
    //         }}
    //     >
    //         {props => (
    //             <div id="comment_submit_form">
    //                 <form className="search-form" onSubmit={props.handleSubmit}>
    //                     {props.errors.search_field && <div className="error">{props.errors.search_field}</div>}
    //                     <input className="search-input"
    //                         name="search_field"
    //                         type="text"
    //                         placeholder="Поиск по сайту"
    //                         onBlur={props.handleBlur}
    //                         value={props.values.search_field}
    //                         onChange={props.handleChange}
    //                         autoComplete="off"
    //                     />
    //                     <button type="submit" className='search_icon'></button>
    //                 </form>
    //             </div>
    //         )}
    //
    //     </Formik>
    //
    // );


    // const handleFetchData = async () => {
    //     const response = await fetch(`https://api.unsplash.com/photos/random?client_id=${process.env.NEXT_PUBLIC_UNSPLASH_API_ACCESS_KEY}`);
    //     const data = await response.json();
    //     console.log(data);
    // }

    // const getSiteResource = async () => {
    //     let root = document.getElementById('root');
    //     let name = root.classList.contains("dark_theme") ? 'site_logo_light' : 'site_logo';
    //     await fetch( global.config.api + `/?method=site_resorce&name=` + name)
    //         .then(response => response.json())
    //         .then(json => {
    //             if (json && json.success) {
    //                 setLogo(json.url)
    //                 root.classList.remove('loading_data');
    //             }
    //         })
    //         .catch(error => console.error('Error fetching data:', error));
    // }

    return (
        <header id='header'>
            <div className='container'>
                <div className='header_inner'>
                    <a href='#' className='logo'>
                        <img src={location.pathname == '/' ? menu.site_logo_light : menu.site_logo} alt="logo"/>
                    </a>
                    <nav className='navigation'>
                        <ul className='navigation_list' dangerouslySetInnerHTML={{__html: checkHTML(menu.header_menu)}}></ul>
                    </nav>
                    <div className='header_search'>
                        {FormikSearchBox()}
                        <button className='autorization'></button>
                        <button className="header_burger_button" type="button" aria-label="Меню" id="burgerBtn"
                                onClick={handleBurgerButton}>
                    <span className="header_burger_button_box">
                        <span></span><span></span><span></span><span></span>
                    </span>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;